let defaultHttpAgent;
let defaultHttpsAgent;
async function defaultAgent(url) {
    // in node environment, lets spin up our default agents once
    if (!defaultHttpAgent) {
        const http = await import('http');
        defaultHttpAgent = new http.Agent({
            keepAlive: true
        });
    }
    if (!defaultHttpsAgent) {
        const https = await import('https');
        defaultHttpsAgent = new https.Agent({
            keepAlive: true
        });
    }
    if (url.toString().startsWith('http:')) {
        return defaultHttpAgent;
    }
    return defaultHttpsAgent;
}
// eslint-disable-next-line import/prefer-default-export
export function withHttpKeepAlive() {
    // browser!
    if (typeof window !== 'undefined') {
        return async (url, init) => {
            return [url, init];
        };
    }
    // node! ....
    return async (url, init) => {
        const agent = await defaultAgent(url);
        return [url, { ...{ agent }, ...init }];
    };
}
//# sourceMappingURL=withHttpKeepAlive.js.map